import { Component, OnInit, Inject } from '@angular/core';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-view-groups',
  templateUrl: './dialog-view-groups.component.html',
  styleUrls: ['./dialog-view-groups.component.scss']
})
export class DialogViewGroupsComponent implements OnInit {

  fetchedGroups : any;
  isUserNull: boolean = false
  displayedGroupsColumns : any[] = ['group']
  constructor(
    public dialogRef: MatDialogRef<DialogViewGroupsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private usersAndGroupsService: UsersAndGroupsService
  ) { }

  ngOnInit() {

    var getGroupsPayload = {
      "user": this.data.Username
    }
    this.usersAndGroupsService.getGroupsForUser(getGroupsPayload).subscribe(users => {
      this.fetchedGroups = users
      if(this.fetchedGroups.length === 0){
        this.isUserNull = true
        console.log("IS USER", this.isUserNull)
      }
    })
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
